var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.telefones),function(tel,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":_vm.colSize}},[_c('crud-telefone',{attrs:{"index":index,"tel-data":{ ...tel },"disabled":_vm.disabled,"store-module":"form","input-outlined":_vm.inputOutlined}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }